import React from 'react';
import { Umbrella, CalendarDays, Settings } from 'lucide-react';
import ConfigCard from '../ConfigCard';
import LeaveEntitlementCard from '../LeaveEntitlementCard';

const LeaveTab = ({ configData, cardProps }) => {
  const { onAddNew, onEdit, onDelete } = cardProps;
  return (
    <div className="space-y-6">
      <LeaveEntitlementCard
        title="Leave Types & Entitlements"
        icon={Umbrella}
        items={configData.leaveTypes}
        category="leaveTypes"
        onAddNew={onAddNew}
        onEdit={onEdit}
        onDelete={onDelete}
      />

      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
          <CalendarDays className="w-5 h-5 text-gray-500" />
          Holiday Management
        </h3>
        <ConfigCard {...cardProps} title="Public Holidays" icon={CalendarDays}
          items={configData.publicHolidays}
          category="publicHolidays"
          fields={['holiday_date', 'holiday_type', 'holiday_is_gazetted']}
        />
      </div>

      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
          <Settings className="w-5 h-5 text-gray-500" />
          Business Rules Configuration
        </h3>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <ConfigCard {...cardProps} title="Application Rules" icon={Settings}
            items={[
              { id: 1, name: "Minimum Advance Notice", value: "7 days", configurable: true },
              { id: 2, name: "Maximum Continuous Days", value: "30 days", configurable: true },
              { id: 3, name: "Weekend Inclusion", value: "Auto-exclude", configurable: true },
              { id: 4, name: "Public Holiday Inclusion", value: "Auto-exclude", configurable: true }
            ]}
            category="applicationRules"
            fields={['value', 'configurable']}
            readOnly={true}
          />
        </div>
      </div>
    </div>
  );
};

export default LeaveTab;
